var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEligibilityChecked(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.777344,
    width: 20,
    height: 20,
    rx: 10,
    fill: "#ECFDF3"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18047_301888)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 10.3183V10.7783C14.9994 11.8565 14.6503 12.9056 14.0047 13.7692C13.3591 14.6327 12.4516 15.2645 11.4177 15.5702C10.3837 15.8759 9.27863 15.8392 8.26724 15.4655C7.25584 15.0919 6.39233 14.4013 5.80548 13.4968C5.21863 12.5923 4.9399 11.5223 5.01084 10.4464C5.08178 9.37053 5.4986 8.34642 6.19914 7.52679C6.89968 6.70716 7.84639 6.13594 8.89809 5.89833C9.9498 5.66071 11.0501 5.76942 12.035 6.20825M15 6.77825L10 11.7833L8.5 10.2833",
    stroke: "#12B76A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18047_301888"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(4 4.77734)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEligibilityChecked);
export default __webpack_public_path__ + "static/media/eligibilityChecked.fccc3d501d5533c0d185a7dce7bef175.svg";
export { ForwardRef as ReactComponent };